module.exports = __webpack_public_path__ + "img/KSC05903.3e223d50.jpg";